/* eslint-disable */

export enum TargetingType {
  RESERVED_0 = 0,
  COUNTRY = 1,
  SITE = 2,
  RESERVED_3 = 3,
  HFB = 4,
  TOPIC = 5,
  COST_CENTER_GROUP = 6,
  UNRECOGNIZED = -1,
}

/** Targeting as it looks in the database */
export interface Targeting {
  id: string;
  upn?: string | undefined;
  type: TargetingType;
}

export interface TargetingResponse {
  item: Targeting | undefined;
}

export interface TargetingList {
  items: Targeting[];
  count: number;
}

/** Targeting object with fallbacks. This is what is actually returned from the service. */
export interface UserTargeting {
  countries: string[];
  sites: string[];
  hfbs: string[];
  companies: string[];
  newsTopics: string[];
  costCenterGroups: string[];
}

export interface FindUserTargetingRequest {
  upn: string;
}

export interface FindManyUserTargetingRequest {
  upnList: string[];
}

export interface FindSegmentTargetingRequest {
  name: string;
}

/** Id is required when deleting a single item. Upn is always required. */
export interface DeleteTargetingRequest {
  id?: string | undefined;
  upn: string;
}

export interface DeleteTargetingResponse {
  count?: number | undefined;
}

export interface CostCenterGroupResponse {
  item: string;
}

export interface CostCenterGroupRequest {
  costCenter: string;
}
